const addons = [
  {
    category: "Entertainment",
    title: "DJ",
    name: "Dionte",
    description:
      "Dionte is a multifaceted performer, accomplished open format DJ and producer, and a professional dancer. His genuine love for music and enthusiasm makes him a fun and pleasant performer to work with, ensuring an enjoyable atmosphere for any event.",
    price: 500,
    thumbnail_url: "https://ukiproductions.com/images/djs/demo-cover.jpg",
  },
  {
    category: "Entertainment",
    title: "DJ",
    name: "Romana",
    description:
      "Romana is an international DJ based in Miami and is known for her musical talent, energy and sense of fashion. Her diverse style of mixing is what sets her apart, ensuring every event is musically unique.",
    price: 600,
    thumbnail_url: "https://ukiproductions.com/images/djs/romilux-2.jpg",
  },
  {
    category: "Entertainment",
    title: "DJ",
    name: "Miguel",
    description:
      "Miguel has since become a well-known and respected entertainer and producer throughout the Latin community. His unique mixes is guaranteed to bring the crowd at your event to the dance floor!",
    price: 500,
    thumbnail_url: "https://ukiproductions.com/images/djs/mate-cover.jpg",
  },
  {
    category: "Entertainment",
    title: "Saxophone",
    name: "John",
    description:
      "John is an accomplished saxophonist and flutist, John is a Grammy nominee and a Latin Grammy winner in the Latin Jazz and Latin Pop/Rock categories.",
    price: 400,
    thumbnail_url:
      "https://ukiproductions.com/images/entertainers/john-michalak-13.jpg",
  },
  {
    category: "Entertainment",
    title: "Guitarist",
    name: "Billy",
    description:
      "Billy is an internationally award winning composer and guitarist known for his instrumental acoustic work whose influences include the styles and techniques of many prominent guitarists.",
    price: 600,
    thumbnail_url:
      "https://i1.wp.com/acousticguitar.com/wp-content/uploads/2020/03/1576690155BS19_BillyStrings_JFaatzMedia2758-1.jpg?fit=750%2C500&ssl=1",
  },
  {
    category: "Entertainment",
    title: "Drummer",
    name: "Simon",
    description:
      "Simon is known to perform as a solo act or alongside the DJ and other live musical instruments creating an exciting twist on the typical live entertainment.",
    price: 400,
    thumbnail_url:
      "https://ukiproductions.com/images/entertainers/drummer-cover.jpg",
  },
  {
    category: "Entertainment",
    title: "Singer",
    name: "Veera",
    description:
      "Veera is a talented singer, composer and songwriter with a sensual and soulful voice. Her performance is sure to take you and your guests back in time, and will compliment any event making it an unforgettable experience!",
    price: 1000,
    thumbnail_url: "https://ukiproductions.com/images/entertainers/veera-1.jpg",
  },
  {
    category: "Entertainment",
    title: "Singer",
    name: "Deb",
    description:
      "A gifted composer, Deb posesses a wide range of uniquely romantic and soulful tunes in her catalog. Along with her work as a published songwriter, recording artist, music producer/arranger, and piano accompanist, Deb’s achievements include three one-woman musical shows.",
    price: 1400,
    thumbnail_url:
      "https://static.wixstatic.com/media/f6d1b3_fb6800cc3be8427a9fcdfef25d70e092.jpg/v1/fill/w_313,h_504,al_c,q_80,usm_0.66_1.00_0.01/f6d1b3_fb6800cc3be8427a9fcdfef25d70e092.webp",
  },
  {
    category: "Entertainment",
    title: "MC",
    name: "Conrad",
    description:
      "With our MC motivator, you can have confidence that your event’s schedule will flow as smoothly as possible in a timely manner, while keeping the guests engaged!",
    price: 500,
    thumbnail_url: "https://ukiproductions.com/images/live-entertainment-1.jpg",
  },
  {
    category: "Media & Extras",
    title: "Photographer",
    name: "",
    description:
      "No matter the theme, size or setting of your event, our team of professional photographers always delivers outstanding quality photographs that are 100% customized to your needs.",
    price: 1000,
    thumbnail_url:
      "https://www.officialroyalwedding2011.org/wp-content/uploads/2019/10/wedding-photographer-1170x780.jpeg",
  },
  {
    category: "Media & Extras",
    title: "Videographer",
    name: "",
    description:
      "If a picture is worth a thousand words, what’s a video worth? Our team of professional and affordable videographers will capture the most important highlights of your event, and creatively tell your story from start to finish.",
    price: 3000,
    thumbnail_url:
      "https://digitalfilmmaker.net/wp-content/uploads/2018/12/videographer-definition.jpg",
  },
  {
    category: "Media & Extras",
    title: "3D Mapping",
    name: "",
    description:
      "3D mapping has the ability to transform any object into a screen. The illusion of everyday, static objects around us becoming animated will drastically improve the atmosphere and aesthetic of any event.",
    price: 4000,
    thumbnail_url: "https://ukiproductions.com/images/3d-mapping-1.jpg",
  },
  {
    category: "Media & Extras",
    title: "Uplighting",
    name: "",
    description:
      "Uplighting is a key component to creating a successful event, and will instantly elevate the appearance of your surroundings. The possibilities are endless!",
    price: 2000,
    thumbnail_url: "https://ukiproductions.com/images/uplighting-13.jpg",
  },
  {
    category: "Media & Extras",
    title: "Decor",
    name: "",
    description:
      "Our professional and fine decor will ensure your guests are provided with the most beautiful presentation.",
    price: 1500,
    thumbnail_url:
      "https://karmaeventlighting.com/wp-content/uploads/2015/10/bentley-art-projects-uplighting-karmaeventlighting-com-3-600x400.jpg",
  },
  {
    category: "Media & Extras",
    title: "Fireworks",
    name: "",
    description:
      "Fireworks are a fantastic way to commemorate any event. Make it unforgettable with a unique fireworks display matched to your taste!",
    price: 1100,
    thumbnail_url:
      "https://qph.fs.quoracdn.net/main-qimg-ce1c48d9605566001d2940247bd7ae34",
  },
];

export default addons;
